import React from 'react';
import { observer } from 'mobx-react-lite';
import {
    ColumnOneOfTwoV2,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { Header } from 'src/domains/layouts/shared/cms/header/header';
import { useAppStateContext } from 'src/AppState/AppState';
import { TabTrigger } from 'src/domains/common/components/tabs/tabs';
import { GlobalPageTabs } from './GlobalPageV2.style';
import { ListItem } from 'src/domains/layouts/shared/cms/listV2/listItem/ListItem';
import { ListContainer } from 'src/domains/layouts/shared/cms/listV2/listItem/List.style';
import { filtersGlobal } from './GlobalPageV2.types';
import { QuestionFormV2 } from './QuestionFormV2/QuestionFormV2';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';

export const GlobalPageV2 = observer(() => {
    const { promotionQuestionsState } = useAppStateContext();
    const { currentQuestion, questionsForViewV2, filters } = promotionQuestionsState;

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwoV2>
                    <Header
                        title='Global'
                        description='This is where you can create a question for users. It will show as a banner when the users logs in. A CTA will direct them to their settings page where there will be a question and a dropdown to select the answer from. You must have a CSV to create a marketing question.'
                    />

                    <GlobalPageTabs>
                        {filtersGlobal.map((viewItem) => (
                            <TabTrigger
                                key={viewItem.id}
                                onClick={() => filters.setActiveItem(viewItem.id)}
                                active={filters.activeItem === viewItem.id}
                                disabled={viewItem.disabled}
                            >
                                {viewItem.label}
                            </TabTrigger>
                        ))}
                    </GlobalPageTabs>

                    <ListContainer>
                        {promotionQuestionsState.areQuestionsLoading === true ? (
                            <LoadingV2
                                dataTest='questions-list-root'
                                title='Loading questions list...'
                            />
                        ) : (
                            questionsForViewV2.map((questionObject) => {
                                return (
                                    <ListItem
                                        key={questionObject.id}
                                        title={questionObject.name}
                                        active={questionObject.active}
                                        question={questionObject}
                                    />
                                );
                            })
                        )}
                    </ListContainer>
                </ColumnOneOfTwoV2>

                <ColumnOneOfTwoV2>
                    <QuestionFormV2
                        isDisabled={promotionQuestionsState.areQuestionsLoading === true}
                        key={`question-form-${currentQuestion?.id}`}
                    />
                </ColumnOneOfTwoV2>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
